class LoadMoreProducts extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('[data-load-more-button]');
    this.label = this.querySelector('[data-load-more-label]');
    this.spinner = this.querySelector('.load-more__spinner');
    this.grid = document.getElementById('product-grid');
    this.sectionId = this.dataset.sectionId;
    this.nextUrl = this.dataset.nextUrl;
    this.defaultLabel = this.label ? this.label.textContent : 'Load more';
    this.loading = false;

    if (this.button) {
      this.button.addEventListener('click', this.onClick.bind(this));
    }
  }

  onClick(event) {
    event.preventDefault();
    this.loadMore();
  }

  async loadMore() {
    if (!this.nextUrl || this.loading || !this.grid) return;
    this.loading = true;
    this.setLoadingState(true);

    try {
      const url = new URL(this.nextUrl, window.location.origin);
      url.searchParams.set('section_id', this.sectionId);

      const response = await fetch(url.toString());
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');

      const newGrid = html.getElementById('product-grid');
      if (newGrid) {
        this.grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
      }

      const newLoadMore = html.querySelector('load-more-products');
      if (newLoadMore && newLoadMore.dataset.nextUrl) {
        this.nextUrl = newLoadMore.dataset.nextUrl;
        this.dataset.nextUrl = newLoadMore.dataset.nextUrl;
        const newLabel = newLoadMore.querySelector('[data-load-more-label]');
        if (newLabel && this.label) {
          this.label.textContent = newLabel.textContent;
          this.defaultLabel = newLabel.textContent;
        }
      } else {
        this.nextUrl = null;
        this.remove();
        return;
      }

      // Move focus to the first newly-loaded product for keyboard/screen-reader users
      if (newGrid && newGrid.firstElementChild) {
        const firstNewItem = this.grid.children[this.grid.children.length - newGrid.children.length];
        if (firstNewItem) {
          const focusTarget = firstNewItem.querySelector('a, button') || firstNewItem;
          focusTarget.setAttribute('tabindex', focusTarget.hasAttribute('tabindex') ? focusTarget.getAttribute('tabindex') : '-1');
        }
      }
    } catch (error) {
      console.error('Load more products failed:', error);
    } finally {
      this.loading = false;
      this.setLoadingState(false);
    }
  }

  setLoadingState(isLoading) {
    if (!this.button) return;
    this.button.disabled = isLoading;
    this.button.setAttribute('aria-busy', String(isLoading));
    if (this.spinner) this.spinner.classList.toggle('hidden', !isLoading);
    if (this.label) this.label.classList.toggle('hidden', isLoading);
  }
}

customElements.define('load-more-products', LoadMoreProducts);
